const nameReducer = (state = {
    type: '',
    purchasePrice: '',
    downPaymentInUSDs: '',
    downPaymentInPercents: '',
    CreditScore: '',
    ShowButtons: false,
    propertyType: '',
    propertyUse: "",
    lowRates: undefined,
    lowRatesOption: undefined,
    estimatedValue: '',
    loanBalance: '',
    loanAmount: '',
    estimatedHomeValue: '',
    cashoutAmount: "",
	zipCode: "",
	countryState: "",
	stateCounty: "",
	veteran: ""
}, action) => {
    switch (action.type) {
        case "TYPESELECTED":
            return { ...state, type: action.payload }
        case "PURCHASEPRICEUPDATE":
            return { ...state, purchasePrice: action.payload }
        case "DOWNPAYMENTINUSDSUPDATE":
            return { ...state, downPaymentInUSDs: action.payload }
        case "DOWNPAYMENTINPERCENTSSUPDATE":
            return { ...state, downPaymentInPercents: action.payload }
        case "CREDITSCOREUPDATE":
            return { ...state, CreditScore: action.payload }
        case "SHOWBUTTONSUPDATE":
            return { ...state, ShowButtons: action.payload }
        case "PROPERTYTYPEUPDATE":
            return { ...state, propertyType: action.payload }
        case "PROPERTYUSEDUPDATE":
            return { ...state, propertyUse: action.payload }
        case "LOWRATESUPDATE":
            return { ...state, lowRates: action.payload }
        case "LOWRATESOPTION":
            return { ...state, lowRatesOption: action.payload }
        case "ESTIMATEDVALUEUPDATED":
            return { ...state, estimatedValue: action.payload }
        case "LOANBALANCEUPDATED":
            return { ...state, loanBalance: action.payload }
        case "CASHOUTAMOUNTUPDATED":
            return { ...state, cashoutAmount: action.payload }
        case "ESTIMATEDHOMEVALUEUPDATED":
            return { ...state, estimatedHomeValue: action.payload }
        case "LOANAMOUNTTOTALUPDATE":
            return { ...state, loanAmount: action.payload }
        case "ZIPCODEUPDATE":
            return { ...state, zipCode: action.payload }
        case "COUNTRYSTATEUPDATE":
            return { ...state, countryState: action.payload }
		case "STATECOUNTYUPDATE":
            return { ...state, stateCounty: action.payload }
		case "VETERANUPDATE":
            return { ...state, veteran: action.payload }
        default:
            return state
    }

}
export default nameReducer